import flow from 'lodash-es/flow';

export const compose = <S extends any[], T>(
    fn: (...args: S) => T,
    ...composers: Array<(res: T) => T>
) => flow(fn, ...composers) as (...args: S) => T;
